import React, { useState, useEffect } from "react";
import Pagination from "../../components/global/pagination/Pagination.jsx";
import columns from "../../columns/DepositReminderLog.js";
import TableWithSkeleton from '../../components/global/table/TableWithSkeleton.jsx';
import { AuditLogByUserIdApi } from '../../api/request/ibCommission.js';
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function DepositReminderLog() {

  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const { userDetails } = useSelector(state => state.user);


  const getDepositReminder = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
      }
      setIsLoading(true);
      const { data } = await AuditLogByUserIdApi(userDetails?._id, new URLSearchParams(params).toString());
      setData(
        data?.data?.map((item) => {
          return {
            ...item,
            createdDate: moment(item?.createdDate).format('DD-MM-YYYY, hh:mm A'),
          };
        })
      );
      setTotalRecord(data?.totalItems);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getDepositReminder();
  }, [page, pageSize]);

  return (
    <div>
      <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
        <TableWithSkeleton columns={columns} data={data} loading={isLoading}  page={page} pageSize={pageSize}/>
      </div>
      <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
    </div>
  )
}
